import { render, staticRenderFns } from "./createitem.vue?vue&type=template&id=6e651c9c&"
import script from "./createitem.vue?vue&type=script&lang=ts&"
export * from "./createitem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createitem.vue"
export default component.exports